(angular => {

  angular.module("EventAccess", ["Config"]);

})(angular);
